import { GetAmbulatoryProcedures } from 'domain/usecases/ambulatory/get-ambulatory-procedures'
import { NewAmbulatoryRepository } from 'repository/interfaces/new-ambulatory-repository'

export class RemoteGetAmbulatoryProcedures implements GetAmbulatoryProcedures {
  private readonly ambulatoryRepository: NewAmbulatoryRepository

  constructor(ambulatoryRepository: NewAmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  get(
    params: GetAmbulatoryProcedures.Params
  ): Promise<GetAmbulatoryProcedures.Model> {
    return this.ambulatoryRepository.getAmbulatoryProcedures(params)
  }
}
